import { useState } from 'react';
import Modal from './Modal';
import './styles/module-games.css';

export default function GameCard({ game }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    id,
    appid,
    appId,
    title,
    cover: customCover,
    steamUrl: customSteamUrl,
    releaseDate,
    developer,
    comment
  } = game;

  // Resolve Steam App ID & URLs automatically if appid/appId is provided
  const steamAppId = appid || appId;
  const cover = customCover || (steamAppId ? `https://shared.cloudflare.steamstatic.com/store_item_assets/steam/apps/${steamAppId}/library_600x900.jpg` : '');
  const steamUrl = customSteamUrl || (steamAppId ? `https://store.steampowered.com/app/${steamAppId}/` : '');

  const hasComment = comment && comment.trim().length > 0;

  return (
    <>
      <div className="game-card">
        {/* Steam portrait cover with right fade gradient mask */}
        {cover && (
          <div className="game-cover-wrap">
            <img src={cover} alt={title} className="game-cover-img" />
          </div>
        )}

        {/* Content area */}
        <div className="game-content">
          <div className="game-title-row">
            <h3 className="game-title">{title}</h3>
          </div>

          <div
            className={`game-comment-wrap ${hasComment ? 'truncated' : ''}`}
            onClick={() => setIsModalOpen(true)}
            style={{ cursor: 'pointer' }}
            title="Click to view details"
          >
            {hasComment ? (
              <p className="game-comment">{comment}</p>
            ) : (
              <p className="game-comment-empty">No review written yet...</p>
            )}
          </div>

          <div className="game-footer">
            <button
              className="game-read-more"
              onClick={() => setIsModalOpen(true)}
            >
              Details →
            </button>

            {steamUrl ? (
              <a
                href={steamUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="game-steam-link"
                onClick={(e) => e.stopPropagation()}
              >
                Steam
              </a>
            ) : null}
          </div>
        </div>
      </div>

      {/* Pop-out detail modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div className="game-modal-hero">
            {cover && <img src={cover} alt={title} className="game-modal-cover" />}
            <div className="game-modal-meta">
              <h2 style={{ fontSize: '1.25rem', fontWeight: 800, color: 'var(--text-primary)', margin: 0 }}>
                {title}
              </h2>

              {developer && (
                <p className="game-meta-item" style={{ marginTop: '0.4rem' }}>
                  <span>Developer:</span>
                  <strong>{developer}</strong>
                </p>
              )}

              {releaseDate && (
                <p className="game-meta-item">
                  <span>Released:</span>
                  <strong>{releaseDate}</strong>
                </p>
              )}

              {steamUrl && (
                <a
                  href={steamUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="game-steam-link"
                  style={{ width: 'fit-content', marginTop: '0.5rem', marginLeft: 0 }}
                >
                  View on Steam Store
                </a>
              )}
            </div>
          </div>

          <hr className="about-divider" style={{ margin: '0.5rem 0' }} />

          <div>
            <h4 style={{
              fontSize: '0.78rem',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '1.2px',
              color: 'var(--text-secondary)',
              margin: '0 0 0.5rem 0'
            }}>
              My Thoughts
            </h4>
            <p style={{
              color: hasComment ? 'var(--text-primary)' : 'var(--text-secondary)',
              fontStyle: hasComment ? 'normal' : 'italic',
              fontSize: '0.93rem',
              lineHeight: '1.65',
              whiteSpace: 'pre-wrap',
              margin: 0
            }}>
              {hasComment ? comment : 'No thoughts or review written yet.'}
            </p>
          </div>
        </div>
      </Modal>
    </>
  );
}
